import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>GIC Laddering Calculator</h1>
        <iframe className={styles.iframe} src="https://www.financialcalculators.net/librocu/gic-laddering/" title="GIC Laddering Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
